exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".seek-time[data-seek-time]{position:absolute;white-space:nowrap;height:20px;line-height:20px;font-size:0;left:-100%;bottom:55px;background-color:rgba(2,2,2,.5);z-index:9999;-webkit-transition:opacity .1s ease;transition:opacity .1s ease}.seek-time[data-seek-time].hidden[data-seek-time]{opacity:0}.seek-time[data-seek-time] [data-seek-time]{display:inline-block;color:#fff;font-size:10px;padding-left:7px;padding-right:7px;vertical-align:top}.seek-time[data-seek-time] [data-duration]{display:inline-block;color:hsla(0,0%,100%,.5);font-size:10px;padding-right:7px;vertical-align:top}.seek-time[data-seek-time] [data-duration]:before{content:\"|\";margin-right:7px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/seek_time/public/seek_time.scss
 ** module id = 133
 ** module chunks = 0
 **/